module.exports = __webpack_public_path__ + "img/banner-left.068c25fd.jpg";